import { Grid } from '@ltvco/refresh-lib/theme';
import { type ReactNode } from 'react';

import { PromoCtaButton, PromoFeatureCard } from './PromoFeatureCard';

export type ReportAttachmentsPromoCardProps = {
  isCompactLayout: boolean;
  mdColumns: number;
  illustration: ReactNode;
  onUploadClick: () => void;
};

export function ReportAttachmentsPromoCard({
  isCompactLayout,
  mdColumns,
  illustration,
  onUploadClick,
}: ReportAttachmentsPromoCardProps) {
  const ctaSxCompact = isCompactLayout ? { flexShrink: 0 as const } : undefined;

  return (
    <Grid
      size={{ xs: 12, md: mdColumns }}
      sx={{ display: 'flex', alignItems: 'stretch' }}
    >
      <PromoFeatureCard
        isCompactLayout={isCompactLayout}
        illustration={illustration}
        title="Add Report Attachments"
        body="Add files, photos, and docs to keep important details organized. Your files will not appear publicly."
        cta={
          <PromoCtaButton
            variant="contained"
            color="primary"
            onClick={onUploadClick}
            data-cy="report-attachments-cta-upload-button"
            sx={ctaSxCompact}
          >
            Add Attachments
          </PromoCtaButton>
        }
      />
    </Grid>
  );
}
